import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../../../lib/constants/reference-data-labels';

@Component({
  selector: 'boi-kfi-progress-stepper',
  templateUrl: './kfi-progress-stepper.component.html',
  styleUrls: ['./kfi-progress-stepper.component.scss']
})
export class KfiProgressStepperComponent {
  @Input() activeTab: any;
  @Input() sections: any;
  @Input() hasSubmitValidationError?: boolean;

  public referenceDataLabels = ReferenceDataLabels;
}
